import ja from 'element-ui/lib/locale/lang/ja';

// 日语(日本)
export default {
  ...ja,
  layout: {
    title: 'Uniportal IDでサインイン',
    tip: '登録されていない携帯電話番号は、ログインに成功すると自動的に登録されます',
    line: 'その他のログインオプション',
  },
  button: {
    submit: 'ログイン/登録',
    getCode: 'コード取得',
    emailRegister: 'メールで登録',
    w3Login: 'W3アカウントログイン',
    employeeLogin: '従業員ログイン',
    passwordLogin: 'パスワードログイン',
    reSend: '再送',
    problem: 'オンラインヘルプ',
    privacyPolicy: 'プライバシーに関する声明',
  },
  placeholder: {
    phoneNumber: '携帯電話番号',
    verificationCode: 'SMS認証コード',
  },
  dialog: {
    imgCode: '画像の文字を入力してください。',
    userAgreements: {
      header: '利用規約と個人情報保護に関する声明',
      text1: '{privacy}および{agreement}をお読みのうえ、これに同意してください。',
      text2:
        'ファーウェイの海外アプリにアクセスする際、個人情報はファーウェイの海外子会社に転送されて処理されます。詳細は{privacy}を参照してください',
    },
    crossBorder: {
      header: '承認のヒント',
      text: 'アカウントが登録されている地域と同じ地域ではないローカルサービスを使用しています。国境を越えたアカウント情報へのアクセスには、お客様の承認が必要です。',
    },
    multiAccounts: 'アカウントを選択',
    agreeButton: '同意して続行',
    disagreeButton: '同意しない',
    confirmButton: '確認',
    cancelButton: 'キャンセル',
    knowMe: '分かった',
  },
  toast: {
    hasSend: '認証コードが送信されました。',
    wait: 'ちょっと待って',
  },
  tooltip: {
    Huawei: 'Huawei ID',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'CAPTCHAコードは必須事項です。',
    'IDC-03-0002': 'CAPTCHAコードの期限切れです。',
    'IDC-00-0004': 'CAPTCHAコードが間違っています。',

    // 表单输入为空
    'IDC-01-00024': '携帯電話番号を認証するために国コードが必要です。',
    phoneNumberEmpty: '携帯電話番号を入力します。',
    'IDC-03-00033': 'SMS認証コードを入力してください。',

    // 表单数据错误
    'IDC-02-00227': '入力された携帯電話番号は、選択した国/地域と一致しません',
    'IDC-02-00226': '国コードは禁止されています',
    'IDC-02-00029': '検証コードが間違っているか、期限切れになっています',
    'IDC-02-0013': 'メールログイン失敗、認証コードエラー',
    'IDC-02-0020': '認証に失敗しました。認証コードが間違っています。',
    'IDC-02-00028': '携帯電話番号は6～30の長さの数字でなければなりません',
    'IDC-02-00012': '携帯電話番号が間違っています',

    // 错误操作锁定
    accountLock: '携帯電話番号または認証コードが間違っています。あと{number}回試行できます。',
    accountLocked: '失敗の試行回数が多すぎます。{number}秒後に再試行してください。',
    operationRisk:
      '現在の操作にはセキュリティリスクがあります。{number}秒後にもう一度やり直してください。',

    // 频繁操作
    'IDC-02-00038': '60秒後に再試行してください。',
    'IDC-02-00064': 'SMS認証コードの送信回数が多すぎます。24時間後に再試行してください。',
    'IDC-02-00211': '現在の操作にはセキュリティリスクがあります。後でやり直してください。',
    'IDC-02-00212':
      'SMS認証コードの送信が頻繁に行われています。お使いの携帯電話番号を変更するか、24時間後にもう一度お試しください。',
    'IDC-02-00213': 'SMS認証コードの送信回数が多すぎます。24時間後に再試行してください。',
    'IDC-02-00215':
      'SMS認証コードの送信が頻繁に行われています。お使いの携帯電話番号を変更するか、別の認証方法を選択するか、24時間後にもう一度お試しください。',
    'IDC-02-00228': 'SMS認証コードの送信回数が多すぎます。1時間後にもう一度お試しください！',
    'IDC-02-00092': '現在の操作の頻度が高すぎます。24時間後にもう一度お試しください。',

    // 请求异常
    'IDC-10-00400': 'お客様の要求に異常がある',
    'IDC-10-00500': 'システム内部エラー',
    'IDC-02-00264': '許可されていないアクセス要求は禁止されています',
    'IDC-02-00063': '不正なパラメータ',
    'IDC-03-0007': '現在の操作にはセキュリティ上の問題があり、一時的に登録できません。', // 机翻
    'IDC-03-00057': '現在の操作にはセキュリティリスクがあります。',

    // 页面过期
    'IDC-00-00017': 'ページの有効期限が切れています。',
  },

  // 注册协议、隐私声明对话框
  backButton: '戻る',
  closeButton: '閉じる',

  // 滑块验证相关：
  resourceReqFailed: 'リソース要求に失敗しました。ページを更新して、再試行してください。',
  verifyFailedAndPlsRetry: '検証に失敗しました。再試行してください',
  serviceErrAndPlsRetry: 'サービス例外です。再試行してください。',
  learnMore: '詳細はこちら',
  cookieBannerText: '当サイトでは、お客様に最高のユーザー体験を提供するためにCookie機能を使用しています。',
};
